import type { ReactNode } from 'react'
import type { SxProps, Theme } from '@mui/material/styles'
import { Card, CardContent, Stack } from '@mui/material'
import ClimateSectionTitle from './ClimateSectionTitle'
import ClimateContentMotion from './ClimateContentMotion'

type ClimateMetricCardProps = {
  title: string
  subtitle?: string
  helpText?: ReactNode
  loading?: boolean
  transitionKey?: string
  children: ReactNode
  variant?: 'elevation' | 'outlined'
  sx?: SxProps<Theme>
  contentSx?: SxProps<Theme>
  stackSpacing?: number
  motionMinHeight?: number
  motionLayout?: 'block' | 'inline'
  motionJustifyContent?: 'flex-start' | 'center' | 'flex-end'
}

const ClimateMetricCard = ({
  title,
  subtitle,
  helpText,
  loading = false,
  transitionKey,
  children,
  variant = 'outlined',
  sx,
  contentSx,
  stackSpacing = 1.25,
  motionMinHeight,
  motionLayout = 'block',
  motionJustifyContent = 'flex-start',
}: ClimateMetricCardProps) => {
  const cardSx = [{ height: '100%' }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]
  const mergedContentSx = Array.isArray(contentSx) ? contentSx : contentSx ? [contentSx] : []
  const content = transitionKey ? (
    <ClimateContentMotion
      transitionKey={transitionKey}
      minHeight={motionMinHeight}
      layout={motionLayout}
      justifyContent={motionJustifyContent}>
      {children}
    </ClimateContentMotion>
  ) : (
    children
  )

  return (
    <Card variant={variant} sx={cardSx}>
      <CardContent sx={mergedContentSx}>
        <Stack spacing={stackSpacing}>
          <ClimateSectionTitle title={title} subtitle={subtitle} helpText={helpText} loading={loading} />
          {content}
        </Stack>
      </CardContent>
    </Card>
  )
}

export default ClimateMetricCard
